import React, { ReactElement } from "react";
import oc from "open-color";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement } from "chart.js";
import t from "../../../helpers/i18n";

ChartJS.register(CategoryScale, LinearScale, BarElement);

export default function WaterLevel({ value, max }: { value: number; max: number }): ReactElement {
  return (
    <>
      <div style={{ position: "absolute", left: "40px", top: "12px" }}>
        <span style={{ fontSize: "16px", fontWeight: "bold" }}>{value}</span>{" "}
        <span>{t("m", "м")}</span>
      </div>
      <div style={{ width: "65px", marginRight: "15px", marginBottom: "-5px" }}>
        <Bar
          width={120}
          data={{
            labels: ["Level"],
            datasets: [
              {
                backgroundColor: oc.blue[7],
                data: [value],
              },
            ],
          }}
          options={{
            maintainAspectRatio: false,
            responsive: true,
            scales: {
              y: {
                beginAtZero: true,
                max,
              },
            },
            plugins: {
              legend: {
                display: false,
              },
            },
            layout: {
              padding: {
                left: 0,
                right: 0,
                top: 30,
                bottom: 0,
              },
            },
          }}
        />
      </div>
    </>
  );
}
